import React, {useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import {loadStripe} from '@stripe/stripe-js';
import {
  PaymentElement,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  Elements,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';
import SoftButton from "../../components/SoftButton";
import SubscriptionService, {activateFreeTrial, getSubscriptionProduct} from "../../services/subscription.service";
import {toast} from "react-toastify";
import SoftTypography from "../../components/SoftTypography";
import {getAppPath} from "../../services/app-path.service";

const FREE_PLAN_ID = (process.env.REACT_APP_STRIPE_FREE_PLAN_ID || "plan_U7BCf1k5ZLEqZ5").trim();

const CheckoutForm2 = ({productId}) => {
  const stripe = useStripe();
  const elements = useElements();


  const [errorMessage, setErrorMessage] = useState(null);
  const handleSubmit = async (event) => {
    event.preventDefault();
    // alert(elements)
    if (elements == null) {
      return;
    }

    // Trigger form validation and wallet collection
    const {error: submitError} = await elements.submit();
    if (submitError) {
      // Show error to your customer
      setErrorMessage(submitError.message);
      return;
    }
      let clientSecret = "";
      await SubscriptionService.generateToken(productId)
        .then((data)=>{
            clientSecret = data.data.data["client_secret"]
        }).catch((e)=>{
            const message = e?.response?.data?.status || e.message || "Could not create subscription";
            toast.error(message, {position: toast.POSITION.BOTTOM_RIGHT, autoClose: 2000, hideProgressBar: false,});
            setErrorMessage(message);
        })

      if (!clientSecret) {
        return;
      }

      const option = {
          //`Elements` instance that was used to create the Payment Element
          elements,
          clientSecret,
          confirmParams: {
              return_url: `${window.location.origin}${getAppPath(`/order?product=${productId}&status=completed`)}`,
          },
      };
    let error;
    if (clientSecret.startsWith("seti_")){
        ({error} = await stripe.confirmSetup(option));
    }else{
        ({error} = await stripe.confirmPayment(option));
    }

    if (error) {
      setErrorMessage(error.message);
    } else {
        localStorage.setItem("active_plan", productId)
    }
  };
    return (
        <form onSubmit={handleSubmit} style={{"textAlign":"center"}}>
          <PaymentElement />
          <SoftButton size={"large"} color={"primary"}  sx={{"marginTop":"2rem"}}  type="submit" disabled={!stripe || !elements} onClick={handleSubmit}>
            Start Subscription
          </SoftButton>
          {/* Show error message to your customers */}
          {errorMessage && <SoftTypography color={"error"} fontWeight={"bold"} sx={{"paddingTop":"1rem"}}>{errorMessage}</SoftTypography>}
        </form>
      );
  };




export default function CheckoutForm ({productId}) {

  const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
  const stripePromise = publishableKey ? loadStripe(publishableKey) : null;
  const [options, setOptions] = useState({})
  const [loadError, setLoadError] = useState("")
    useEffect(()=>{
        setLoadError("");
        setOptions({});
        if ((productId || "").trim() === FREE_PLAN_ID) {
            setLoadError("Activating free trial...");
            activateFreeTrial(productId)
                .then(() => {
                    localStorage.setItem("has_plan", "1");
                    localStorage.setItem("active_plan", productId);
                    toast.success("Free trial activated.", {position: toast.POSITION.BOTTOM_RIGHT, autoClose: 2000, hideProgressBar: false});
                    window.location.href = getAppPath("/dashboards/home");
                })
                .catch((e) => {
                    const message = e?.response?.data?.status || "Could not activate free trial";
                    setLoadError(message);
                    toast.error(message, {position: toast.POSITION.BOTTOM_RIGHT, autoClose: 2500, hideProgressBar: false});
                });
            return;
        }
        if (!publishableKey) {
            setLoadError("Stripe publishable key is not configured on dashboard frontend.");
            return;
        }
        SubscriptionService.getSubscriptionProduct(productId)
        .then((data)=>{
            const amount = Number(data?.data?.data?.amount || 0);
            const currency = data?.data?.data?.currency || "usd";
            const commonOptions = {
                currency,
                appearance: {labels: 'floating'},
            };

            setOptions({
                ...commonOptions,
                ...(amount > 0
                    ? { mode: "subscription", amount: amount * 100 }
                    : { mode: "setup" }),
            })
        }).catch((e)=>{
            const backendMessage = e?.response?.data?.status;
            const message = backendMessage || "Stripe is not configured on server.";
            setOptions({});
            setLoadError(message);
            toast.error(message, {position: toast.POSITION.BOTTOM_RIGHT, autoClose: 2000, hideProgressBar: false});
        })
    },[productId, publishableKey])

    // alert(productId)
  return (
      stripePromise && options.hasOwnProperty("mode") ? (
        <Elements stripe={stripePromise} options={options}>
          <CheckoutForm2 productId={productId} />
        </Elements>
      ) : (
        <SoftTypography color={"text"} fontWeight={"bold"} sx={{"paddingTop":"1rem"}}>
          {loadError || "Loading payment form..."}
        </SoftTypography>
      )
  )
}
